var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "HelpSidePanel" },
    [
      _c(
        "transition",
        { attrs: { name: "slide-fade" } },
        [
          _c(
            "b-card",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.help,
                  expression: "help"
                }
              ],
              staticClass: "help-sidepanel"
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn  btn-outline-primary",
                    class: { "btn-primary": _vm.help },
                    on: {
                      click: function($event) {
                        _vm.help = !_vm.help
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("HelpSidePanel.close")) + "\n            "
                    ),
                    _c("i", { staticClass: "fa fa-close" })
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._t("default")
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/HelpSidePanel.vue?vue&type=template&id=1d0f99d2&
// module id = null
// module chunks = 